/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const STREAM_TYPE_OPTIONS = optionsProxy.create([
  { value: 'udp', get label() { return i18n.t('lunaStreams:constants.stream_type.udp'); } },
  { value: 'tcp', get label() { return i18n.t('lunaStreams:constants.stream_type.tcp'); } },
  { value: 'videofile', get label() { return i18n.t('lunaStreams:constants.stream_type.videofile'); } },
  { value: 'images', get label() { return i18n.t('lunaStreams:constants.stream_type.images'); } },
]);

export const SENDING_TYPE_OPTIONS = optionsProxy.create([
  { value: 'sec', get label() { return i18n.t('lunaStreams:constants.sending_type.sec'); } },
  { value: 'frames', get label() { return i18n.t('lunaStreams:constants.sending_type.frames'); } },
]);

export const FRAME_PROCESSING_MODE_OPTIONS = optionsProxy.create([
  { value: 'auto', get label() { return i18n.t('lunaStreams:constants.frame_processing_mode.auto'); } },
  { value: 'full', get label() { return i18n.t('lunaStreams:constants.frame_processing_mode.full'); } },
  { value: 'scale', get label() { return i18n.t('lunaStreams:constants.frame_processing_mode.scale'); } },
]);

export const LIVENESS_MODE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('lunaStreams:constants.liveness_mode.0'); } },
  { value: 1, get label() { return i18n.t('lunaStreams:constants.liveness_mode.1'); } },
  { value: 2, get label() { return i18n.t('lunaStreams:constants.liveness_mode.2'); } },
]);

export const STREAM_STATUS_OPTIONS = optionsProxy.create([
  { value: 'pending', get label() { return i18n.t('lunaStreams:constants.stream_status.pending'); } },
  { value: 'in_progress', get label() { return i18n.t('lunaStreams:constants.stream_status.in_progress'); } },
  { value: 'done', get label() { return i18n.t('lunaStreams:constants.stream_status.done'); } },
  { value: 'pause', get label() { return i18n.t('lunaStreams:constants.stream_status.pause'); } },
  { value: 'restart', get label() { return i18n.t('lunaStreams:constants.stream_status.restart'); } },
  { value: 'cancel', get label() { return i18n.t('lunaStreams:constants.stream_status.cancel'); } },
  { value: 'failure', get label() { return i18n.t('lunaStreams:constants.stream_status.failure'); } },
  { value: 'handler_lost', get label() { return i18n.t('lunaStreams:constants.stream_status.handler_lost'); } },
  { value: 'not_found', get label() { return i18n.t('lunaStreams:constants.stream_status.not_found'); } },
  { value: 'deleted', get label() { return i18n.t('lunaStreams:constants.stream_status.deleted'); } },
]);

export const CREATE_STREAM_STATUS_OPTIONS = optionsProxy.create([
  { value: 'pending', get label() { return i18n.t('lunaStreams:constants.stream_status.pending'); } },
  { value: 'pause', get label() { return i18n.t('lunaStreams:constants.stream_status.pause'); } },
]);

export const ROTATION_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return '0'; } },
  { value: 90, get label() { return '90'; } },
  { value: 180, get label() { return '180'; } },
  { value: 270, get label() { return '270'; } },
]);
